import * as d3Array from 'd3-array';
import * as d3Collection from 'd3-collection';
import * as d3Scale from 'd3-scale';
import * as d3Shape from 'd3-shape';
import * as d3Format from 'd3-format';

import Chart from './components/containers/chart.vue';
import FlexibleChart from './components/containers/flexible-chart.vue';
import WidgetText from './components/containers/widget-text.vue';

import Grid from './components/layers/grid.vue';
import Legend from './components/layers/legend.vue';
import Area from './components/layers/area.vue';
import Bars from './components/layers/bars.vue';
import Donut from './components/layers/donut.vue';
import Heatmap from './components/layers/heatmap.vue';

import Labels from './components/labels/labels.vue';
import Axis from './components/labels/axis.vue';
import AxisTick from './components/labels/axis-tick.vue';

import Bar from './components/datum/bar.vue';
import Rect from './components/datum/rect.vue';

import identity from './lib/transforms/identity';
import categorical from './lib/transforms/categorical';
import scheme from './lib/transforms/scheme';

export const transforms = { identity, categorical, scheme };

const d3 = { ...d3Array, ...d3Collection, ...d3Scale, ...d3Shape, ...d3Format };

const DatalasCharts = {
  Chart,
  FlexibleChart,
  WidgetText,
  Grid,
  Legend,
  Area,
  Bars,
  Heatmap,
  Donut,
  Labels,
  Axis,
  AxisTick,
  Bar,
  Rect,
};

DatalasCharts.install = (Vue) => {
  // eslint-disable-next-line no-param-reassign
  Vue.config.globalProperties.$d3 = d3;

  // HACK: Wrap d3 format in a function that replaces G (Giga) suffix with B
  // (Billions) and k (lowercase) with K (uppercase). Use with `~s`.
  // eslint-disable-next-line no-param-reassign
  Vue.config.globalProperties.$format = (specifier) => {
    const dropPercent = specifier.endsWith('%-');
    const normalizedSpecifier = specifier.replace(/%-$/, '%');

    const format = d3.format(normalizedSpecifier);

    return (...x) => {
      const formattedString = format(...x)
        .replace(/G$/, 'B')
        .replace(/k$/, 'K');

      return dropPercent ? formattedString.replace(/%$/, '') : formattedString;
    };
  };

  Object.keys(DatalasCharts).forEach((key) => {
    const component = DatalasCharts[key];
    if (component.name) Vue.component(component.name, component);
  });
};

export default DatalasCharts;
